export default async (id) => {
  const response = await fetch(`http://localhost:5001/orderinfo/${id}`)
  const json = await response.json()
  const orders = await json.Orders
  return orders
}
